import { render, staticRenderFns } from "./TagsManagerListContent.vue?vue&type=template&id=4efe6319&scoped=true&"
import script from "./TagsManagerListContent.vue?vue&type=script&lang=js&"
export * from "./TagsManagerListContent.vue?vue&type=script&lang=js&"
import style0 from "./TagsManagerListContent.vue?vue&type=style&index=0&id=4efe6319&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efe6319",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
